var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.963 4.763c.576-1.657-2.838-3.313-3.7-1.419l-.867 1.343c1.56-.25 3.334.53 4.164 1.703l.402-1.627Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.06 17.795C9.527 19.922 7.625 21.5 5.354 21.5 2.67 21.5.5 19.294.5 16.582c0-2.49 3.468-10.047 3.468-10.047C5.85 4.191 9.983 5.45 10.546 7.949c0 0 .144.756.354 1.604a2.701 2.701 0 0 1 1.032-.192c.38 0 .74.067 1.058.203.268-.852.464-1.615.464-1.615.563-2.5 4.696-3.758 6.578-1.414 0 0 3.468 7.556 3.468 10.047 0 2.712-2.17 4.918-4.854 4.918-2.271 0-4.173-1.578-4.706-3.705l.005.282h-.01A1.95 1.95 0 0 1 12 19.837a1.95 1.95 0 0 1-1.935-1.76h-.01l.005-.282Zm3.107.086A1.17 1.17 0 0 1 12 19.055a1.17 1.17 0 0 1-1.167-1.174A1.17 1.17 0 0 1 12 16.708a1.17 1.17 0 0 1 1.167 1.173ZM8.34 16.75c0 1.749-1.404 3.167-3.136 3.167-1.733 0-3.137-1.418-3.137-3.167 0-1.749 1.404-3.167 3.137-3.167 1.732 0 3.136 1.418 3.136 3.167Zm10.455 3.167c1.732 0 3.136-1.418 3.136-3.167 0-1.749-1.404-3.167-3.136-3.167-1.733 0-3.137 1.418-3.137 3.167 0 1.749 1.404 3.167 3.136 3.167Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.037 4.763c-.576-1.657 2.838-3.313 3.7-1.419l.867 1.343c-1.56-.25-3.334.53-4.164 1.703l-.402-1.627Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.3ed2ea9f7431f3721041e3853fdcfeaa.svg";
export { ForwardRef as ReactComponent };